<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">

           <div class="col-12">
            <button routerLink="/createflyclient" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'Create Client' | translate }}
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->
            
          <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="ابحث بالاسم او رقم التليفون او رقم الباسبور او العنوان" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>



          </div>
        </div>
        <div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

  <!-- Name -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
    <td mat-cell *matCellDef="let el">
      {{ el.name }}
      <br>
      <span style="color:#d00;font-size:10px">{{ el.notes }}</span>
    </td>
  </ng-container>

  <!-- Address -->
  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef>{{ 'address' | translate }}</th>
    <td mat-cell *matCellDef="let el">{{ el.address }}</td>
  </ng-container>

  <!-- Phone -->
  <ng-container matColumnDef="phone">
    <th mat-header-cell *matHeaderCellDef>{{ 'Phone Number' | translate }}</th>
    <td mat-cell *matCellDef="let el">{{ el.phone }}</td>
  </ng-container>

  <!-- Passport -->
  <ng-container matColumnDef="passport_number">
    <th mat-header-cell *matHeaderCellDef>{{ 'Passport' | translate }}</th>
    <td mat-cell *matCellDef="let el">{{ el.passport_number }}</td>
  </ng-container>

  <!-- Trip Type -->
  <ng-container matColumnDef="trip_type">
    <th mat-header-cell *matHeaderCellDef>نوع الرحله</th>
    <td mat-cell *matCellDef="let el">{{ tripTypeLabel(el.trip_type) }}</td>
  </ng-container>

  <!-- Trip Date -->
  <ng-container matColumnDef="trip_date">
    <th mat-header-cell *matHeaderCellDef>تاريخ الرحلة</th>
    <td mat-cell *matCellDef="let el">{{ el.trip_date | date:'yyyy-MM-dd' }}</td>
  </ng-container>

  <!-- Arrival Date -->
  <ng-container matColumnDef="arrival_date">
    <th mat-header-cell *matHeaderCellDef>تاريخ الوصول</th>
    <td mat-cell *matCellDef="let el">
      {{ el.arrival_date ? (el.arrival_date | date:'yyyy-MM-dd') : '-' }}
    </td>
  </ng-container>
    <ng-container matColumnDef="call">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'call' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="call(el.phone_number)">
                  <img src="/assets/call.png" alt="Call">
                </a>
              </td>
            </ng-container>

            <!-- Chat -->
            <ng-container matColumnDef="chat">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'chat' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="chat(el.phone_number)">
                  <img src="/assets/chat.png" alt="Chat">
                </a>
              </td>
            </ng-container>
  <!-- Options -->
  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let el">
      <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="edit(el)">{{ 'Edit' | translate }}</a></li>
          <li><a class="dropdown-item" (click)="delete(el.id)">{{ 'Delete' | translate }}</a></li>
        </ul>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>


          <mat-paginator
            style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
            [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>

        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>